<template>
<div>
  <div v-if="this.$route.params.txid">
    <router-view></router-view>
  </div>
  <div v-else class="page-admin show-cards-in-sequence-- show-cards-up--">
    <div class="col-12">
      <div class="row">
        <card-component
          style="min-height: calc(100vh - 300px);"
          :block="false"
          title="Atendimentos"
          subtitle=""
          :col="{ xs: 12 }"
          @onselect="selecionouOpcao"
          @onselect2="selecionouOpcao2"
          @onselect3="selecionouOpcao3"
          :select="[
            { id: null, name: 'Últimos cadastros' },
            { id: 'first', name: 'Mais antigos' }
          ]"
          :select2="[
            { id: null, name: 'Etapa da transação' },
            { id: 'CREATED', name: 'Criado' },
            { id: 'STARTED', name: 'Iniciado' },
            { id: 'ANALYSIS', name: 'Em Análise' },
            { id: 'INSTALLMENT_SELECTION', name: 'Seleção de Parcela' },
            { id: 'CONTRACT', name: 'Contrato' },
            { id: 'VERIFICATION_PHONE', name: 'Verificação Telefone' },
            { id: 'VERIFICATION_DOCUMENT', name: 'Verificação Documento' },
            { id: 'VERIFICATION_SELFIE', name: 'Verificação Selfie' },
            { id: 'WAITING_FOR_APPROVAL', name: 'Esperando Aprovação' },
            { id: 'ABANDONED', name: 'Abandonado' },
            { id: 'REJECTED', name: 'Rejeitado' },
            { id: 'APPROVED', name: 'Aprovado - Pagamentos Pendentes' },
            { id: 'CANCELED', name: 'Cancelado' },
            { id: 'FINISHED', name: 'Finalizado' },
            {
              id: 'REJECTED_PURCHASE_OVER_LIMIT',
              name: 'Compra fora do limite'
            },
            { id: 'REJECTED_SPC_RESTRICTION', name: 'Restrição no SPC' }
          ]"
          :select3="sellers"
        >
          <follow-up-list-component
            :refreshList="refreshList"
            :orderList="orderList"
            :stepList="stepList"
            :seller="seller"
            :showCollapse="true"
          ></follow-up-list-component>
        </card-component>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import Navbar from '../../partial/navbar/Navbar.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Background from '../../partial/background/Background.vue'
import Input from '../../partial/form/Input.vue'
import Login from '../../partial/cards/login/Login.vue'
import Button from '../../partial/button/Button.vue'
import Banner from '../../partial/cards/banner/Banner.vue'
import FollowUpList from '../../partial/customerservice/FollowUpListNew'

export default {
  components: {
    FollowUpList,
    'card-component': Card,
    'navbar-component': Navbar,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'login-component': Login,
    'button-component': Button,
    'input-component': Input,
    'banner-component': Banner,
    'follow-up-list-component': FollowUpList
  },
  data () {
    return {
      avatarimage: '',
      appbg: '/static/bgs/2.jpg',

      stats: {
        transactionsCount: 0,
        transactionsSentCount: 0,
        transactionsSentPerc: 0,
        transactionsSignedCount: 0,
        transactionsSignedPerc: 0,
        contractCount: 0,
        contractPerc: 0
      },

      linkReport:
        process.env.API + '/api/users/report?exportFormat=excel&extension=xls',
      sellers: null
    }
  },
  methods: {
    setAppBg (image) {
      this.appbg = image
    },
    setAvatarImage (image) {
      this.avatarimage = image
    },
    selecionouOpcao (value) {
      this.$store.dispatch('selecionouOpcao', value)
      console.log('OPCAO ' + value)
    },
    selecionouOpcao2 (value) {
      this.$store.dispatch('selecionouOpcao2', value)
    },
    selecionouOpcao3 (value) {
      this.$store.dispatch('selecionouOpcao3', value)
    },
    getStats () {
      this.$http
        .get('api/customerservice/stats')
        .then(function (res) {
          console.log(res)
          this.stats = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getSellers () {
      this.$http
        .get('api/selects/sellers')
        .then(function (res) {
          console.log(res)
          this.sellers = res.data.list
          this.sellers.splice(0, 0, { id: null, name: 'Selecione o cliente' })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  computed: {
    refreshList () {
      return this.$store.state.refreshList
    },
    orderList () {
      return this.$store.state.orderList
    },
    stepList () {
      return this.$store.state.stepList
    },
    seller () {
      return this.$store.state.seller
    }
  },
  mounted () {
    this.getStats()
    this.getSellers()
    this.$ga.page('/#/admin')
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "../../../assets/scss/card.scss";
</style>



// WEBPACK FOOTER //
// src/components/pages/customerservice/CustomerServiceHomeNew.vue